import React from 'react';
import { CustomerTiles } from 'src/components/CustomerTiles';
import { PageHeading } from 'src/components/page-heading/page-heading';
import { IShipTo, ISoldTo } from 'src/graphql/types';
import { White } from 'src/styles/colours';
import styled from 'styled-components';
import { SoldToPageBreadcrumb } from '../sold-to/breadcrumbs';

const StyledTopSection = styled.div`
  background-color: ${White};
  padding: 0rem 0rem 3rem 7.5rem;
`;

export const SoldToTopSection = ({
  soldTo,
  shipTo,
}: {
  soldTo: ISoldTo;
  shipTo?: IShipTo;
}) => {
  return (
    <StyledTopSection>
      <SoldToPageBreadcrumb soldTo={soldTo} />
      <PageHeading>Sold-To details</PageHeading>
      <CustomerTiles
        soldTo={soldTo}
        shipTo={shipTo}
        isVmiSite={shipTo?.vmiIndicator}
      />
    </StyledTopSection>
  );
};
